// RequestResetPassword.js
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useSendResetLinkMutation } from "../slices/authSlice";
import Input from "../components/utilComponents/Input";
import Button from "../components/utilComponents/Button";
import Error from "../components/message/Error";
import Success from "../components/message/Success";
import { validateEmail } from "../utils/validation";

const RequestResetPassword = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [sendResetLink] = useSendResetLinkMutation();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateEmail(email)) {
      setError("Invalid email address");
      return;
    }
    setLoading(true);
    setError("");
    setSuccess("");
    try {
      await sendResetLink(email).unwrap();
      setSuccess(
        "If an account exists with that email, you'll receive a password reset link shortly",
      );
    } catch (error) {
      setError("Error sending reset link");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-agBg">
      <div className="bg-white p-8 rounded-xl shadow-md w-96">
        {error && <Error message={error} onClose={() => setError("")} />}
        {success && (
          <Success message={success} onClose={() => setSuccess("")} />
        )}
        <form onSubmit={handleSubmit}>
          <Input
            type="email"
            placeholder="Enter your email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            isFullWidth
          />
          <Link to="/login">
            <p className="mt-4 text-sm text-agBlue text-right mb-4">
              I've remembered my password
            </p>
          </Link>
          <Button
            type="submit"
            variant="primary"
            fullWidth={true}
            isActive={!loading}
            isLoading={loading} // Added isLoading prop
          >
            {loading ? "Sending..." : "Send Reset Link"}
          </Button>
        </form>
      </div>
    </div>
  );
};

export default RequestResetPassword;
